import {getCookie, getCookieName} from '../../common/utils/cookieUtils'
import {ApiService} from '../ApiService'
import {SettingsDto, UpdateSettingsBody} from './type'

class SettingsServiceProvider extends ApiService {
  async getSettings(): Promise<SettingsDto> {
    return await this.get<SettingsDto>(`/activations/settings`, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }

  async updateSettings(body: UpdateSettingsBody): Promise<SettingsDto> {
    return await this.patch<SettingsDto>(`/activations/settings`, body, {
      headers: {
        Authorization: `Bearer ${getCookie(getCookieName())}`,
      },
    })
  }
}

export const SettingsService = new SettingsServiceProvider()
